import type { NavGroup } from '@graftcode/design-system'

import { hrefMatchesNavRoute } from './hrefMatchesNavRoute'
import { resolveSidebarNavTestId } from './resolveSidebarNavTestId'

type NavItemWithTestId = {
  id?: string
  label?: string
  url?: string
}

export function applySidebarNavTestIds(container: HTMLElement, menuGroups: NavGroup[]): void {
  for (const group of menuGroups) {
    for (const item of group.items) {
      const navItem = item as NavItemWithTestId
      const testId = navItem.id ? resolveSidebarNavTestId(navItem.id) : undefined
      const url = navItem.url
      const label = navItem.label

      if (!testId) continue

      const links = container.querySelectorAll('a[href]')

      links.forEach((link) => {
        const href = link.getAttribute('href') ?? ''

        if (url) {
          if (hrefMatchesNavRoute(href, url)) {
            link.setAttribute('data-testid', testId)
          }

          return
        }

        const text = link.textContent?.trim() ?? ''
        const matchesLabel = label ? text.toLowerCase() === label.toLowerCase() : false

        if (matchesLabel) {
          link.setAttribute('data-testid', testId)
        }
      })
    }
  }
}
